// service/ops.service.js
//
// Cliente API del panel de OPERACIONES (admin):
//   - Ventas en vivo (anomalías)
//   - Salud de cupos + reconciliación
//   - Reembolsos (cobros duplicados) + marcar estado
//   - Cuadre de caja diario

import { v2Get, v2Post } from './client.js';

const BASE = '/v2/admin/ops';

const OpsV2 = {
  ventasEnVivo: async ({ lookback = 180, grace = 15 } = {}) => {
    const r = await v2Get(`${BASE}/ventas-en-vivo`, { params: { lookback, grace } });
    return r.data || r;
  },

  saludCupos: async ({ todos = false, ciclosCerrados = false } = {}) => {
    const r = await v2Get(`${BASE}/cupos`, {
      params: { todos: String(todos), ciclosCerrados: String(ciclosCerrados) }
    });
    return r.data || r;
  },

  /**
   * GET /v2/admin/ops/cupos/:horarioId
   * La evidencia del drift: qué inscripciones contó el contador y cuáles no, y por qué.
   * Va aparte del listado porque el cruce es caro.
   */
  detalleCupo: async (horarioId) => {
    const r = await v2Get(`${BASE}/cupos/${horarioId}`);
    return r.data?.data || r.data || r;
  },

  reconciliarCupos: async ({ horarioIds = [], apply = false } = {}) => {
    const r = await v2Post(`${BASE}/cupos/reconciliar`, { horarioIds, apply });
    return r.data || r;
  },

  reembolsos: async ({ desde, hasta } = {}) => {
    const params = {};
    if (desde) params.desde = desde;
    if (hasta) params.hasta = hasta;
    const r = await v2Get(`${BASE}/reembolsos`, { params });
    return r.data || r;
  },

  /**
   * Bandeja única de casos (online + presencial). Sin `desde`, el backend arranca en
   * el lunes de esta semana: lo viejo se pide explícitamente.
   */
  casos: async ({ desde, hasta, tipo, incluirCerrados } = {}) => {
    const params = {};
    if (desde) params.desde = desde;
    if (hasta) params.hasta = hasta;
    if (tipo) params.tipo = tipo;
    if (incluirCerrados) params.incluirCerrados = 'true';
    const r = await v2Get(`${BASE}/casos`, { params });
    return r.data || r;
  },

  /** Paso 2: todas las variables del caso, con la solución que sugiere el backend. */
  detalleCaso: async (origen, id) => {
    const r = await v2Get(`${BASE}/casos/${origen}/${id}`);
    return r.data || r;
  },

  marcarReembolso: async (pagoId, { estado, medio, notas } = {}) => {
    const r = await v2Post(`${BASE}/reembolsos/${pagoId}`, { estado, medio, notas });
    return r.data || r;
  },

  cuadreDiario: async ({ dia } = {}) => {
    const params = {};
    if (dia) params.dia = dia;
    const r = await v2Get(`${BASE}/cuadre`, { params });
    return r.data || r;
  },
};

export default OpsV2;
